import { observer } from 'mobx-react';
import React, { useState } from 'react';
import logo from '../../images/logo.png';
import logo_succubus from "../../images/logo_succubus.png";
import { GAME_STATES } from '../../js/ids';
import SGMSClient from '../../js/SGMSClient';
import { store } from '../../stores/store';
import ConnectForm from './ConnectForm/ConnectForm';
import CreateAccountForm from './CreateAccountForm/CreateAccountForm';
import MeetingForm from './MeetingForm/MeetingForm';
import './Menu.css';
import PublicMeetingsButtons from './PublicMeetingsButtons/PublicMeetingsButtons';



const PAGES = {
  LOGIN: "LOGIN",
  CREATE_ACCOUNT: "CREATE_ACCOUNT",
  PLAY_SOLO: "PLAY_SOLO",
  MEETING_CODE: "MEETING_CODE"
}


const StartMenu = () => {

  const [page, setPage] = useState(PAGES.LOGIN);
  const [newUserPopup, setNewUserPopup] = useState(false);

  const handleSelect = (e) => {
    store.language = e.target.value
  }

  const handlePlaySoloClick = () => {
    // ici voir si on erase ou pas
    let { LocalStorageUserKey } = window.CONFIG.vertexConfig
    if(SGMSClient.savedUserExists(LocalStorageUserKey)) {
      setNewUserPopup(true)
    } else {
      connectUser()
    }
  }


  function eraseUserAndConnect() {

    let { LocalStorageUserKey } = window.CONFIG.vertexConfig
    localStorage.removeItem(LocalStorageUserKey)
    connectUser()
  }

  function connectUser() {
    setNewUserPopup(false)
    let { Universe, App, LocalStorageUserKey } = window.CONFIG.vertexConfig
    SGMSClient.logout()
    .then(() => SGMSClient.reconnect(Universe, App, LocalStorageUserKey))
    .then(() => setPage(PAGES.PLAY_SOLO))
    .catch(() => alert("Connection error"))
  }




  const handleBackClick = () => setPage(PAGES.LOGIN)
  const handleCreateAccount = () => setPage(PAGES.CREATE_ACCOUNT)
  const handleConnectSuccess = () => setPage(PAGES.MEETING_CODE)

  let _news = store.t("news", "")

  return (
    <div className="start-menu">
      {store.gameState === GAME_STATES.LOADING &&
      <>
        <div className="loader" />
        <div className="spacer" />
      </>
      }


      {store.gameState === GAME_STATES.LOADED &&
      <>
        {_news !== "" &&
        <div className="news" dangerouslySetInnerHTML={{__html: _news}} />}

        {SGMSClient.currentUser && SGMSClient.currentUser.UserPseudo &&
        <div className="user_login">
          {store.t("connected_as")} <strong>{SGMSClient.currentUser.UserPseudo}</strong>
        </div>}

        <div className="logo">
          <img src={logo} alt=""/>
        </div>

        <div className="language-selector">
          {store.t("choose_game_language")}
          <select value={store.language} onChange={handleSelect}>
            {window.CONFIG.languages.map(l => <option key={l}>{l}</option>)}
          </select>
        </div>

        {page === PAGES.LOGIN &&
        <div>
          <div className='play-solo-button'>
            <button onClick={handlePlaySoloClick}>{store.t("play_offline")}</button>
          </div>
          <h3>{store.t("login_account")}</h3>
          <ConnectForm onFormSuccess={handleConnectSuccess} />



          <div className='play-solo-button'>
            <button onClick={handleCreateAccount}>{store.t("create_account")}</button>
          </div>
        </div>}

        {page === PAGES.MEETING_CODE &&
        <div>
          <h3>{store.t("choose_scenario")}</h3>
          <PublicMeetingsButtons />

          <MeetingForm />

          <div className='play-solo-button'>
            <button onClick={handleBackClick}>{store.t("menu_back_button")}</button>
          </div>
        </div>}



        {page === PAGES.CREATE_ACCOUNT &&
        <div>
          <h3>{store.t("create_an_account_title")}</h3>
          <CreateAccountForm onFormSuccess={handleConnectSuccess} />
          <div className='play-solo-button'>
            <button onClick={handleBackClick}>{store.t("menu_back_button")}</button>
          </div>
        </div>}

        {page === PAGES.PLAY_SOLO &&
        <div>
          <h3>{store.t("choose_scenario")}</h3>
          <PublicMeetingsButtons />
          <div className='play-solo-button'>
            <button onClick={handleBackClick}>{store.t("menu_back_button")}</button>
          </div>
        </div>}


        {newUserPopup &&
        <div className="overlay">
          <div className="new-user-popup">
            <div className="close" onClick={() => setNewUserPopup(false)}>&times;</div>
            <h3 dangerouslySetInnerHTML={{__html: store.t("new_user_popup_title")}} />
            <p dangerouslySetInnerHTML={{__html:  store.t("new_user_popup_content")}} />
            <div className="new-user-popup-btns">
              <button onClick={eraseUserAndConnect} >{store.t("new_user_popup_erase_btn")}</button>
              <button onClick={connectUser}>{store.t("new_user_popup_keep_btn")}</button>
            </div>
          </div>
        </div>}





        <div className="bottom_links">
          <div>
            <a target="_blank" href={store.t("link_scenario_creator")}>Scenario creator</a>
            <a target="_blank" href={store.t("link_teacher_app")}>Teacher app</a>
          </div>
        </div>


        <footer>
          <div>
            <img src={logo_succubus} alt="logo_succubus"/>
            <span>Seriously made with fun by <a target="_blank" href="https://www.succubus.fr">Succubus Interactive</a>. (v{process.env.REACT_APP_VERSION})</span>
          </div>
        </footer>

      </>}








    </div>
  );
};

export default observer(StartMenu);
